import moment from "moment";
import { useEffect, useRef } from "react";
import type { ProcedureType, SourcingEventPatchDto } from "../../../../../autogen/bff-api";
import { hasRequestStage, isQualificationScheme, isTwoStageProcedure } from "../utils/procedure";

const SUGGESTED_REQUEST_DEADLINE_DAYS = 35;

const suggestedRequestDeadlineIso = (): string =>
  moment()
    .add(SUGGESTED_REQUEST_DEADLINE_DAYS, "days")
    .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
    .toISOString();

interface SuggestedRequestDeadline {
  publicContext: { procedureType?: ProcedureType | null; governingSchemeId?: string | null } | null;
  requestDeadline: string | null;
  isSaving: boolean;
  updateField: (fields: Partial<SourcingEventPatchDto>) => void;
}

export const useSuggestedRequestDeadline = ({
  publicContext,
  requestDeadline,
  isSaving,
  updateField,
}: SuggestedRequestDeadline): void => {
  const seededRef = useRef(false);

  useEffect(() => {
    if (seededRef.current) return;
    if (!hasRequestStage(publicContext)) return;
    if (requestDeadline !== null) return;
    if (isSaving) return;
    seededRef.current = true;
    updateField({
      eventData: {
        requestDeadline: suggestedRequestDeadlineIso(),
        requestDeadlineConfirmed: false,
      },
    });
  }, [publicContext, requestDeadline, isSaving, updateField]);
};
